import { eventKeyConstants } from './eventKey';

export const radioGroupHelper = (refID : string, cb : any, event : any) => {
  const refElem = document.getElementById(refID);
  const focusableElements = refElem.querySelectorAll(
    '[role="radio"]'
  )
  const focusableRowArr = Array.prototype.slice.call(focusableElements);
  const focusRowIndex = focusableRowArr?.indexOf(event.target);

  switch (event.key) {
    case eventKeyConstants.ARROWUP:
    case eventKeyConstants.ARROWLEFT:
      event.preventDefault();
      if (focusRowIndex === 0) {
        focusableRowArr[focusableRowArr.length - 1]?.focus();
      } else {
        focusableRowArr[focusRowIndex - 1]?.focus();
      }
      cb();
      break;
    case eventKeyConstants.ARROWDOWN:
    case eventKeyConstants.ARROWRIGHT:
      event.preventDefault();
      if (focusRowIndex === focusableRowArr.length - 1) {
        focusableRowArr[0]?.focus();
      } else {
        focusableRowArr[focusRowIndex + 1]?.focus();
      }
      cb();
      break;
    default:
      break;
  }
}
